import { MatDividerModule } from '@angular/material/divider';
// File: cgp-app-bar-menu-module.ts
// Author: James L Seebach
// Date: 5/12/2017
// Desc: CGP App Bar Menu module.
// Other Contributors: Joseph M Diaz

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyMenuModule as MatMenuModule } from "@angular/material/legacy-menu";

import { CgpAppBarUserMenuComponent } from "./cgp-app-bar-user-menu.component";
import { CgpUserProfileDialogModule } from "../../cgp-user-profile-dialog/cgp-user-profile-dialog.module";
import { CgpUserProfileDialogService } from "../../cgp-user-profile-dialog/cgp-user-profile-dialog.service";

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        MatMenuModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        CgpUserProfileDialogModule
    ],
    exports: [
        CgpAppBarUserMenuComponent
    ],
    declarations: [
        CgpAppBarUserMenuComponent
    ],
    providers: [
        CgpUserProfileDialogService
    ]
})
export class CgpAppBarUserMenuModule { }
